/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetWarehouseExportUsageQueryParams = NonNullable<
  operations['getWarehouseExportUsage']['parameters']['query']
>;

export interface Input {
  apiVersion?: string;
  query?: GetWarehouseExportUsageQueryParams;
}

export async function getWarehouseExportUsage(
  { apiVersion, query }: Input = {},
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/usage/warehouse-export', {
    params: { query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
